module.exports = __webpack_public_path__ + "static/media/main-small-section-right-1.752672d2.png";